import { Testimonial } from '../../model/testimonial/testimonial.model';
import { ThemeColorSettings } from '../theme/theme.data';

const DEFAULT_REVIEW = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse in elit blandit, tempus risus vitae, elementum eros. Suspendisse nec orci at neque molestie dignissim.';

export const TESTIMONIALS: Testimonial[] = [
  {
    review: "SR Engineers understands our business pressures and delivers accordingly. Their commitment to quality and last-minute sales support has made them indispensable to our operations. They have shipped our material even at odd hours for us to not have an impact on our operations at our plant, which makes them one of the most reliable partners we have",
    reviewer: {
      name: 'Aerospace Industry',
      title: 'CEO @ LeeSoft.au',
      photoUri: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/common/businessman-4.png',
      social: {
        linkedIn: '',
        twitter: '',
      },
    },
    theme: ThemeColorSettings.orange,
  },
  {
    review: "SR Engineers & Alcade Engineers have been our go-to suppliers for industrial lubricants, welding equipment and all other industrial needs. Their teams understand our requirements and ensure all the required material reaches our plant before the requested delivery date. Whenever we have faced issues, their team resolves them promptly and professionally, without us having to follow up",
    reviewer: {
      name: 'Cement Industry',
      title: $localize`:@@testimonials.title.???:CEO @ Your Company`,
      photoUri: '',
      social: {
        linkedIn: '',
        twitter: '',
      },
    }
  },
  {
    review: "Alcade Engineers has consistently delivered quality welding supplies and industrial consumables right when we need them. Their customer service is proactive, making them a trusted name in our industry",
    reviewer: {
      name: 'Cement Industry',
      title: $localize`:@@testimonials.title.???:CEO @ Your Company`,
      photoUri: '',
      social: {
        linkedIn: '',
        twitter: '',
      },
    }
  },
  {
    review: "SR Engineers consistently goes above and beyond to understand our unique requirements.Their team is always approachable, and their deliveries have never missed a deadline.We have never wanted to switch our suppliers",
    reviewer: {
      name: 'Manufacturing Industry',
      title: 'CTO @ SmartCoderz.ai',
      photoUri: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/common/businessman-1.png',
      social: {
        linkedIn: '',
        twitter: '',
      }
    },
    theme: ThemeColorSettings.orange,
  },
  {
    review: "We’ve been impressed with Alcade Engineers range of products and their commitment to service. Their deliveries are on-time, and their team is always available for support",
    reviewer: {
      name: 'Infrastructure Industry',
      title: $localize`:@@testimonials.title.???:CEO @ Your Company`,
      photoUri: '',
      social: {
        linkedIn: '',
        twitter: '',
      },
    }
  },
  {
    review: "What sets SR Engineers apart is their personal touch. Every order we place with them for our lubrication requirements comes with the assurance of timely delivery, and should we ever need assistance, their team is always just a call away",
    reviewer: {
      name: 'Cement Industry',
      title: 'CEO @ NomadicSoftt.uk',
      photoUri: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/common/businessman-2.png',
      social: {
        linkedIn: '',
        twitter: '',
      },
    },
    theme: ThemeColorSettings.orange,
  },
  {
    review: "Alcade Engineers has been our go-to supplier for welding and maintenance equipment. Their team understands our production cycles and always delivers on time. Whenever we’ve faced issues, they resolve them promptly and professionally",
    reviewer: {
      name: 'Cement Industry',
      title: $localize`:@@testimonials.title.???:CEO @ Your Company`,
      photoUri: '',
      social: {
        linkedIn: '',
        twitter: '',
      },
    }
  },
  {
    review: "The team in-charge of Taegutec products at SR Engineers is always eager to understand our requirements in detail. Their punctual deliveries and exceptional follow-up support have earned our long-term loyalty",
    reviewer: {
      name: 'Aerospace Industry',
      title: 'Co-Founder @ BrightKode.nl',
      photoUri: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/common/businesswoman-3.png',
      social: {
        linkedIn: '',
        twitter: '',
      },
    },
    theme: ThemeColorSettings.orange,
  },
  {
    review: "Alcade Engineers customer service is outstanding. They ensure we receive our orders without delay and provide dedicated support whenever we have questions or concerns",
    reviewer: {
      name: 'Aerospace Industry',
      title: $localize`:@@testimonials.title.???:CEO @ Your Company`,
      photoUri: '',
      social: {
        linkedIn: '',
        twitter: '',
      },
    }
  },
  {
    review: "We've been working with SR Engineers for over five years now, and their customer-first approach is evident in every interaction. They provide the best of prices, fulfil orders promptly, and their team is quick to address any concerns",
    reviewer: {
      name: 'Steel Industry',
      title: 'Co-Founder @ CloudzNet.io',
      photoUri: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/common/businesswoman-1.png',
      social: {
        linkedIn: '',
        twitter: '',
      },
    },
    theme: ThemeColorSettings.orange,
  },
  {
    review: "Alcade Engineers stands out for their customer-first approach. They proactively coordinate with us to meet urgent requirements, and their post-sales service ensures we never face unnecessary downtime",
    reviewer: {
      name: 'Automobile Industry',
      title: 'Co-Founder @ CloudzNet.io',
      photoUri: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/common/businesswoman-1.png',
      social: {
        linkedIn: '',
        twitter: '',
      },
    },
    theme: ThemeColorSettings.orange,
  },
];
